import Modal from "../../Unknown/Modal";
import { useAppDispatch, useAppSelector } from "../../../modules/store/hooks";
import { modalsSlice } from "../../../modules/store/reducers/modalsSlice";
import CustomPhoneInput from '../../UI/PhoneInput';
import { Box, Button, Checkbox, FormControlLabel, Typography } from "@mui/material";
import { useMemo, useState } from "react";
import translate from "../../../i18n/translate";
import { userApi } from "../../../modules/services/userService";
import toast from "react-hot-toast";
import { generateOtpCode, isValidOtpPhone } from "../../../common/otp";

export default function SendOtpModal() {
  const dispatch = useAppDispatch();
  const [phn, setPhn] = useState('+972')
  const [isStatic, setIsStatic] = useState(false)
  const [isPhoneInvalid, setIsPhoneInvalid] = useState(false)
  const { toggleSendOtpModal } = modalsSlice.actions;
  const visible = useAppSelector((state) => state.modalsReducer.sendOtp);

  const [
    sendOtp,
    { isLoading }
  ] = userApi.useSendOtpMutation();

  const optCode = useMemo(() => {
    return generateOtpCode();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible])

  const onPhoneChange = (value: string) => {
    setPhn(value);
    setIsPhoneInvalid(false);
  }

  const sendAdminOtp = () => {
    const phoneDigits = phn.replace(/\D/g, '');

    if (!isValidOtpPhone(phoneDigits)) {
      setIsPhoneInvalid(true);
      return;
    }

    sendOtp({ phone: phoneDigits, otp: optCode, isStatic })
      .unwrap()
      .then(() => {
        navigator.clipboard.writeText(optCode);
        toast.success(translate(isStatic ? 'otpSetStaticSuccess' : 'otpSetSuccess'))
      }).catch(() => {
        toast.error(translate('otpSetFailed'))
      })
  };

  const onCloseModal = () => {
    setPhn('+972');
    setIsStatic(false);
    setIsPhoneInvalid(false);
    dispatch(toggleSendOtpModal());
  }

  return (
    <Modal
      title={translate("otpModalTitle")}
      visible={visible === "open"}
      style={{ maxWidth: "500px" }}
      setVisible={onCloseModal}
    >
      <Box my={2} p={2} display="flex" flexDirection="column" justifyContent="center" width={1} alignItems="center" gap={2}>
        <Box width={1}>
          <CustomPhoneInput phone={phn} setPhone={onPhoneChange}/>
          {isPhoneInvalid && (
            <Typography variant="body2" color="error" mt={1}>
              {translate("otpPhoneInvalid")}
            </Typography>
          )}
        </Box>
        <Typography variant="h3">{optCode}</Typography>
        <Box display="flex" flexDirection="column" alignItems="center">
          <FormControlLabel
            control={<Checkbox color="warning" checked={isStatic} onChange={(e) => setIsStatic(e.target.checked)} />}
            label={translate("otpIsStatic")}
          />
          {isStatic && (
            <Typography variant="body2" color="text.secondary" textAlign="center">
              {translate("otpIsStaticHint")}
            </Typography>
          )}
        </Box>
        <Button
          size="large"
          variant="contained"
          color="warning"
          onClick={sendAdminOtp}
          disabled={isLoading}
          >
          {translate("setOtp")}
        </Button>
      </Box>
    </Modal>
  );
}
